import React from 'react';
import Header from '../../exemplos/Header/Header';
import SidePanel, { AuthorizedProduct } from '../../exemplos/SidePanel/SidePanel';
import Footer from '../../exemplos/Footer/Footer';

import styles from './LayoutDefault.module.scss';

export interface LayoutDefaultProps {
  links?: AuthorizedProduct[],
}

const LayoutDefault: React.FC<LayoutDefaultProps> = ({ children, links }) => (
  <>
    <Header />
    <section className={styles.container}>
      <div className={styles.cont}>
        <SidePanel links={links} />
        <main className={`${styles.mainContainer}`}>
          { children }
        </main>
      </div>
    </section>
    <Footer />
  </>
);

export default LayoutDefault;
